/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Model from 'flarum/common/Model';

export default class Achievement extends Model {
	id = Model.attribute('id');
	name = Model.attribute('name');
	description = Model.attribute('description');
	order = Model.attribute('order');
	isVisible = Model.attribute('isVisible');
	userCount = Model.attribute('userCount');

	category = Model.hasOne('category');
	levels = Model.hasMany('levels');
	users = Model.hasMany('users');
	userAchievements = Model.hasMany('userAchievements');
	rule = Model.attribute('rule');
}
